module.exports = {"Airset/Nobake Mold":"Airset/Nobake Mold","Centrifugal":"Centrifugal","Continuous Cast":"Continuous Cast","Die Cast":"Die Cast","Graphite Mold":"Graphite Mold","Green Sand":"Green Sand","Ingot":"Ingot","Investment Casting":"Investment Casting","Lost Foam":"Lost Foam","Mold & Core Making":"Mold & Core Making","Permanent Mold":"Permanent Mold","Plaster Mold":"Plaster Mold","Sand & Binders":"Sand & Binders","Semi-permanent Mold":"Semi-permanent Mold","Semi-solid":"Semi-solid","Shell Mold":"Shell Mold","Squeeze Cast":"Squeeze Cast","V-process":"V-process"}


//////////////////
// WEBPACK FOOTER
// ./src/config/moldCastingProcess.json
// module id = 5415
// module chunks = 1